module.exports = __webpack_public_path__ + "media/images/default-avatar-51033331b598451741fdec7055bdfa53.jpg";